<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>E-Sign Agreement </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='1' *ngIf="webFirst">
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/RLUj"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->



                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">

                    <label for="" class="mt-3">At PayG, the e-Agreement feature is
                        designed to
                        streamline
                        and
                        simplify your agreement processes. Gone are the days of dealing with
                        cumbersome
                        paper
                        contracts and manual signatures. With E-Agreement, we bring you a digital
                        solution
                        that
                        enhances efficiency, security, and convenience. </label>
                    <label for="" class="mt-3">E-Agreement transforms the way you
                        engage in
                        agreements
                        with
                        our
                        payment gateway services. Seamlessly integrated into our platform, this
                        feature
                        enables
                        you to create, review, and finalize agreements electronically, all within a
                        secure
                        and
                        user-friendly environment. </label>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">
                    <h2>
                        Key Advantages of E-Agreement:
                    </h2>

                    <ul>
                        <li class="mt-3">
                            <b> Effortless Workflow: </b>&nbsp;Say goodbye to paper-based workflows.
                            E-Agreement
                            allows you to initiate, negotiate, and finalize agreements entirely
                            online,
                            reducing
                            delays and administrative hassles.
                        </li>
                        <li class="mt-3">
                            <b> Anywhere, Anytime Access: </b>&nbsp;Access your agreements from
                            anywhere
                            with an
                            internet connection. No more waiting for physical copies or in-person
                            meetings.
                        </li>

                        <li class="mt-3">
                            <b> Faster Processing: </b>&nbsp;Expedite the agreement process with
                            automated
                            notifications, reminders, and real-time updates on agreement status.
                        </li>

                        <li class="mt-3">
                            <b> Enhanced Security: </b>&nbsp;Your data's security is paramount.
                            E-Agreement
                            ensures secure document transmission, digital authentication, and
                            encryption
                            to
                            safeguard sensitive information.


                        </li>
                    </ul>

                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="4">
                    <h2>
                        How to sign your e-sign?
                    </h2>
                    <label for="">The following steps outline the procedure for signing the e-sign.</label>

                    <label for="" class="mt-4"><b>Step 1:&nbsp;</b> Log in to the Merchant Dashboard </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-1.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"><b>Step 2:&nbsp;</b> Go to Settings > Document Details. Select PEP Status & Product/Service Description before E-signing the agreement.  </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-2.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    
                    <label for="" class="mt-4">If the merchant is a Politically Exposed Person (PEP), they should click on ‘Yes, fill in all the necessary details, and then click on the ‘Save’ button.  </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-3.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <!-- <label for="" class="mt-4">If the merchant is a Politically Exposed Person (PEP), they should click on ‘Yes, fill in all the necessary details, and then click on the ‘Save’ button.  </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-4.png" width="100%" height="100%" alt="">
                        </div>
                    </div> -->

                    <label for="" class="mt-4"> <b>Step 3: &nbsp;</b> After filling in all the necessary details Merchant should click on the Save Button </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-4.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 4: &nbsp;</b> On the dashboard, when the agreement is ready with PayG, the merchant should click the 'Verify' button to sign the agreement.</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-5.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 5: &nbsp;</b> Click on Go for E-sign button, to continue the E-sign process.</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-6.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 6: &nbsp;</b> Now Merchant should copy the Aadhar Number linked with the mobile number as displayed on the screen and click on Click here to Sign button</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-7.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 7: &nbsp;</b>The Digio window will open, click on Send code to Mobile Number for verification</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-8.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 8: &nbsp;</b>Merchant will receive an OTP on the mobile phone, the Merchant should enter that OTP here.</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-9.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 9: &nbsp;</b>After entering the OTP Merchant should click on the Submit button to continue the process</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-10.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 10: &nbsp;</b>Click on the Sign Now button to Sign the Agreement.</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-11.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 11: &nbsp;</b>Merchant should paste the copied Aadhar Number from the last window over here, Merchant will receive an OTP for Aadhar verification, enter that OTP and click on Submit Button.</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-12.svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>Step 12: &nbsp;</b>: When the merchant clicks the 'Submit' button and their account is successfully signed with PayG, the merchant can close the Digio tab. The merchants can check the status of their E-sign process after signing the document.</label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-13.svg" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-14.svg" width="100%" height="100%" alt="">
                        </div>


                    </div>  

                    
               
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
                    <a href="#1"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                E-Agreement </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-3">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">
                                    E-Agreement </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">Advantages
                                </span>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">How to sign your e-sign?
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2 mt-3 ">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/PayG E-Sign Agreement Process.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    E-Sign Agreement </span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/PayG E-Sign Agreement Process.pdf" download><img src="./assets/Downloadss.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/merchant-dashboard']"> <button class="btn btn-color" (click)="menues('merchant')"> <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Merchant-Dashboard
                    </button></a>

            </div>
            
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/web-integration']"> <button class="btn btn-color"
                        (click)="menues('Web Integration')">Web
                        Integration
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>

</div>